import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api/lib/api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Icon, TripadvisorRatingIcon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./TripAdvisorRating.module.scss";

export type TripAdvisorRatingProps = PlatformComponentProps & {
  hotel: Lodging;
};

export const TripAdvisorRating = ({
  hotel,
  className,
}: TripAdvisorRatingProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.TripAdvisorRating,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreHotelsComponent.TripAdvisorRating
  );
  const { t } = useI18nContext();

  const { tripAdvisorReviews: reviews } = hotel.lodging;

  if (!reviews) {
    return null;
  }

  return (
    <div className={clsx(block, className)}>
      <Icon
        useCurrentColor={false}
        className={cn("tripadvisor-icon")}
        iconName={IconNameEnum.tripadvisor}
      />
      <TripadvisorRatingIcon scoreOutOfFive={(reviews.overallScore * 10) / 2} />
      <div className={cn("tripadvisor-review-count")}>
        <span aria-hidden="true">({reviews.reviewsCount})</span>
        <VisuallyHidden>
          {t("core-hotels.shop.customerReviews.reviewCount", {
            count: reviews.reviewsCount,
          })}
        </VisuallyHidden>
      </div>
    </div>
  );
};
